// extracted by mini-css-extract-plugin
module.exports = {"ModalUpload":"styles_ModalUpload__soVlT","ModalUpload-input":"styles_ModalUpload-input__19s30"};